class spPopup extends HTMLElement {
  constructor() {
      super();
      this.popUpContainer = this.querySelector('.sp-popup__container');
      this.popUpOpener = this.querySelector('.sp-popup__opener');
      this.popUpCloser = this.querySelectorAll('.sp-popup__closer');
      this.init()
  }

  setListeners() {
      this.popUpOpener.addEventListener('click', () => {
        this.popUpContainer.classList.add('sp-popup__container--open')
      })

      this.popUpCloser.forEach(closer => {
        closer.addEventListener('click', () => {
          this.popUpContainer.classList.remove('sp-popup__container--open')
        })
      })
  }

  relocatePopup() {
    const body = document.querySelector('body')
    body.appendChild(this.popUpContainer)
  }

  init() {
      this.setListeners()
      this.relocatePopup()
  }
}
customElements.define('sp-popup', spPopup);
